<ng-template #stationTemplate let-name="name" let-date="date" let-diff="diff">
  <div class="flex-col flex-gap-8" style="max-width:200px">
    <span class="text-color-black font-size-14 font-weight-500">{{name}}</span>
    <span class="text-color-light-blue font-size-18 font-weight-600">{{date | date:'HH:mm'}}
      @if (diff > 0) {
        <span><sup>+{{diff}}</sup></span>
      }
    </span>
  </div>
</ng-template>

<div style="width: 100%" class="cursor-pointer" (click)="onSelect.emit()">
  <trenitalia-train-breadcrumbs [trains]="travelSolution.trains"></trenitalia-train-breadcrumbs>
  <div class="flex-row items-start justify-between mt-16">
    <div class="flex-row flex items-center justify-between flex-gap-16">
      <ng-container [ngTemplateOutlet]="stationTemplate" [ngTemplateOutletContext]="{name: departureStationName, date: travelSolution.departure, diff: dayDiffDeparture}"></ng-container>
      <div class="flex text-center durations flex-row items-center flex-gap-8">
        <div class="duration-sign flex"></div>
        <div class="travel-time text-color-black font-size-14">
          <span class="text-color-black font-size-14 font-weight-600">{{travelSolution.duration}}</span>
          <br/>
          @if (travelSolution.trains.length>1) {
            <small>
              {{travelSolution.trains.length - 1}} cambi
            </small>
          }
        </div>
        <div class="duration-sign flex"></div>
      </div>
      <ng-container [ngTemplateOutlet]="stationTemplate" [ngTemplateOutletContext]="{name: arrivalStationName, date: travelSolution.arrival, diff: dayDiffArrival}"></ng-container>
    </div>
    <div class="p-2 text-right flex-basis-5">
      <button class="details" mat-button (click)="onDetails.emit();$event.stopPropagation();">
        <span class="text-color-dark-blue">Dettagli</span>
        <mat-icon iconPositionEnd class="text-color-light-blue ml-4">info</mat-icon>
      </button>
    </div>
    <div class="p-2 text-right flex-basis-5">
      @if (checkoutDataMode == 'edit-date-time') {
        @if (isSelected) {
          <button mat-flat-button disabled color="accent">
            Selezionato
          </button>
        }
        @if (!isSelected) {
          <button mat-button  (click)="onSelect.emit();$event.stopPropagation();">
            Seleziona
          </button>
        }
      }
      @if (checkoutDataMode != 'edit-date-time' && !isCarnet) {
        @if (travelSolution.saleable) {
          <div >
            @if (travelSolution.bestPrice) {
              <div class="flex-row justify-end flex-gap-14 items-center">
                <div class="flex flex-col justify-end text-right text-color-black flex-gap-4">
                  <span class="font-size-12 font-weight-600">A partire da</span>
                  <span class="font-size-14 font-weight-500">{{travelSolution.bestPrice.amount | currency:'EUR':'symbol':'1.2-2'}}</span>
                </div>
                <mat-icon class="text-color-black">keyboard_arrow_down</mat-icon>
              </div>
            }
            @if (!travelSolution.bestPrice) {
              @if (!isSelected) {
                <button mat-button (click)="onSelect.emit();$event.stopPropagation()">
                  Seleziona <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                </button>
              }
            }
          </div>
        }
        @if (!travelSolution.saleable) {
          <div>
            Non selezionabile
          </div>
        }
      }
      @if (checkoutDataMode != 'edit-date-time' && isCarnet && !travelSolution.bestPrice) {
        <div>
          @if (isSelected) {
            <button mat-flat-button disabled color="accent">
              Selezionato
            </button>
          }
          @if (!isSelected) {
            <button mat-button (click)="onSelect.emit();$event.stopPropagation()">
              Seleziona <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>